import type { Session, User } from "@supabase/supabase-js";
import { atom } from "jotai";

export const sessionAtom = atom<Session | null | undefined>(undefined);

export const userAtom = atom<User | null | undefined>((get) => {
  const session = get(sessionAtom);
  return session === undefined ? undefined : (session?.user ?? null);
});

export const isSignedInAtom = atom<boolean | undefined>((get) => {
  const user = get(userAtom);
  return user === undefined ? undefined : !!user;
});

export const userIdAtom = atom<string | null | undefined>((get) => {
  const user = get(userAtom);
  return user === undefined ? undefined : (user?.id ?? null);
});

export const hasStravaWritePermissionsAtom = atom<boolean | undefined>(
  (get) => {
    const user = get(userAtom);
    if (user === undefined) return undefined;
    const scope = user?.user_metadata?.scope;
    return scope?.includes("write") ?? false;
  },
);

export const userFeatureFlagsAtom = atom<
  { [key: string]: boolean } | undefined
>((get) => {
  const user = get(userAtom);
  if (user === undefined) return undefined;
  return user?.user_metadata?.featureFlags;
});

export const showHeatmapFlagAtom = atom<boolean | undefined>((get) => {
  const userFeatureFlags = get(userFeatureFlagsAtom);
  if (userFeatureFlags === undefined) return undefined;
  return userFeatureFlags?.heatmap;
});
